export const LOCAL_STORAGE_SESSION_TOKEN_KEY = 'sessionToken'
export const HTTP_HEADER_SESSION_TOKEN_KEY = 'X-Session-Token'

export const STYLE_FILL_COLOR = 'fillColor'